import { Breadcrumbs, Layout } from '@components/common'
import getAllStores from '@lib/algolia/get-all-stores'
import getGlobalStaticProps from '@lib/get-global-static-props'
import { slugify } from '@lib/helpers/general'
import { createClient } from '@lib/prismicio'
import { StoreFinderPage } from '@lib/store-finder-page'
import { StoreItem, StoreLocation } from '@lib/store-finder-page/types'
import { AnalyticsPageType } from '@shopify/hydrogen-react'
import { GetStaticPropsContext } from 'next'

interface Props {
  stores: StoreLocation[]
}

function StoreFinder({ stores = [] }: Props) {
  const currentRegion = 'au'

  const allStores: StoreItem[] = stores
    .filter((x) => x?.lat && x?.lng)
    .map((s, k) => ({
      id: s?.objectID,
      name: s?.title ?? '',
      address: [
        s?.address_line_1,
        s?.address_line_2,
        s?.suburb,
        s?.state,
        s?.postcode,
      ].join(', '),
      email: s?.email ?? 'N/A',
      phone: s?.phone_number ?? 'N/A',
      handle: s?.slug ?? slugify(s?.title ?? `store-${k}`),
      location: {
        lat: s?.lat,
        lng: s?.lng,
      },
      state: s.state ?? '',
      clickAndCollectAvailable: false,
      distance: 0,
      locationObj: { ...s, id: s?.objectID },
    }))

  return (
    <div className="wrapper fit mb-12">
      <Breadcrumbs current="Store Locations" />
      <StoreFinderPage
        componentRestrictions={{
          country: currentRegion,
        }}
        stores={allStores}
        selectedStoreId={null}
      />
    </div>
  )
}

export async function getStaticProps({
  previewData,
  locale,
}: GetStaticPropsContext) {
  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)
  const stores = await getAllStores()

  return {
    props: {
      ...globalProps,
      stores,
      analyticsPayload: {
        pageType: AnalyticsPageType.page,
      },
    },
  }
}

StoreFinder.Layout = Layout

export default StoreFinder
